import React, { useEffect, useState } from 'react';
import { db } from '@root/firebase';
import { doc, collection, onSnapshot } from 'firebase/firestore';

/**
 * GetViews - Displays a views badge with a tooltip showing total views.
 *
 * Props:
 * - docPath: string (Firestore path, can be doc OR collection)
 * - showTooltip: boolean (default true)
 */
function GetViews({ docPath, showTooltip = true }) {
  const [totalViews, setTotalViews] = useState(0);

  useEffect(() => {
    if (!docPath) return;
    const parts = docPath.split('/').filter(Boolean);

    let unsub;

    // 👇 If even number of segments → it's a document
    if (parts.length % 2 === 0) {
      const ref = doc(db, ...parts);
      unsub = onSnapshot(ref, (snap) => {
        if (snap.exists()) {
          setTotalViews(snap.data().totalViews || 0);
        } else {
          setTotalViews(0);
        }
      });
    } else {
      // 👇 If odd number of segments → it's a collection
      const ref = collection(db, ...parts);
      unsub = onSnapshot(ref, (snap) => {
        let sum = 0;
        snap.forEach((d) => {
          sum += d.data().totalViews || 0;
        });
        setTotalViews(sum);
      });
    }

    return () => unsub && unsub();
  }, [docPath]);

  return (
    <div
      className="tooltip-container"
      style={{ display: 'inline-block', marginRight: '10px' }}
    >
      <button
        type="button"
        className="reaction-btn reaction-views"
        disabled
        title="Views"
      >
        <i className="fas fa-binoculars reaction-icon" />
      </button>
      {showTooltip && <span className="tooltip">{totalViews} Views</span>}
    </div>
  );
}

export default GetViews;